import { acss } from '@adornis/chemistry/directives/acss.js';
import { XProgressBar } from '@adornis/chemistry/elements/components/x-progress-bar.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './cr-tooltip.js';
import './fonts.js';

/**
 * @customElement cr-progress-bar
 */
@customElement('cr-progress-bar')
export class ChromiumProgressBar extends XProgressBar {
  @property({ type: Boolean }) showTooltip = true;

  override styles = () => {
    return [
      {
        ':host': {
          display: 'block',
          height: this.spacing.sm,
          transition: `height .5s ease, background-color .5s ease`,
          position: 'relative',
          backgroundColor: this.colors.primary.shade(200),
          borderRadius: '14px',
          overflow: 'hidden',
        },
        '#progress': {
          height: '100%',
          width: '100px',
          background: this.colors.primary,
          transformOrigin: 'left',
        },
        ...Object.keys(this.colors.tone).reduce(
          (acc, toneKey) => ({
            ...acc,
            [`:host([tone=${toneKey}])`]: {
              backgroundColor: this.colors.tone[toneKey]!.shade(200),
              '#progress': { background: this.colors.tone[toneKey] },
            },
          }),
          {},
        ),
      },
    ];
  };

  public override render() {
    return html`
      <div
        id="progress"
        ${acss({
          transition: `transform ${this.transitionDuration}s linear`,
          transform: `scaleX(${(
            Math.min((this.value || 0) * (this.size.width ?? 0), this.size.width ?? 0) / 100
          ).toFixed(2)})`,
        })}
      >
        ${this.showTooltip
          ? html`<cr-tooltip> <cr-text>${(this.value * 100).toFixed(2)}%</cr-text> </cr-tooltip>`
          : nothing}
      </div>
    `;
  }
}
